<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData"  ref="form" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="materialName" label="物料名称">
              {{ formData.materialName||'--' }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="materialSpec" label="物料规格">
              {{ formData.materialSpec||'--' }}

            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="materialType" label="物料类型">
              {{ formData.materialType||'--' }}

            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'MaterialsManageDetail',
  data () {
    return {
      specList: [],
      formData: {
        materialName: '',
        materialSpec: '',
        materialType: ''
      }

    }
  },
  created () {
    if (this.materialId) {
      this.loadData()
    }
  },
  computed: {
    materialId () {
      return this.$route.query.materialId
    }

  },
  methods: {

    loadData () {
      this.$axios.get(this.$apis.materialsManage.selectYcMaterialByMaterialId, {
        params: { materialId: this.materialId }
      }).then(res => {
        this.formData = res || {}
      })
    }

  }
}
</script>

<style scoped lang='scss'>

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
